var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIns2IconDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4065 5.33333H23.4299C23.4299 5.33333 24.0907 5.33333 24.0907 5.99999V19.8687V26C24.0907 26.6667 23.4299 26.6667 23.4299 26.6667H19.9158H8.89303C8.89303 26.6667 8.23157 26.6667 8.23157 26V12.132V5.99999C8.23157 5.33333 8.89303 5.33333 8.89303 5.33333H12.4065ZM21.4073 19.2958H10.8355V17.9625H21.4073V19.2958ZM10.8355 21.9145H17.924V20.5812H10.8355V21.9145ZM20.1365 14.7853H14.8253V12.7853H20.1365V14.7853ZM13.4959 14.7853H12.1665V12.7853H13.4959V14.7853ZM20.1365 11.452H14.8253V9.45195H20.1365V11.452ZM13.4959 11.452H12.1665V9.45195H13.4959V11.452ZM21.4089 16.1186H10.8371V8.11862H21.4089V16.1186Z",
    fill: "#6F7687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIns2IconDocuments);
export default __webpack_public_path__ + "static/media/ins2-icon-documents.a721702cbc5764d5e70aab8b77cbe180.svg";
export { ForwardRef as ReactComponent };